<template>
  <div>

    <!-- [ Title form ] start -->
    <el-row  :gutter="20" type="flex" justify="center" class="">
      <el-col :span="24">
        <div>
          <h2 v-html="title"></h2>
        </div>

      </el-col>
    </el-row>
    <!-- [ Title form ] end -->

  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>